import { render, staticRenderFns } from "./region-orders-table.vue?vue&type=template&id=3283c9c0&scoped=true&"
import script from "./region-orders-table.js?vue&type=script&lang=js&"
export * from "./region-orders-table.js?vue&type=script&lang=js&"
import style0 from "./region-orders-table.scss?vue&type=style&index=0&id=3283c9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3283c9c0",
  null
  
)

export default component.exports